import { useMemo } from "react";
import {
    Grid2 as Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Typography
} from "@mui/material";
import { Campaign } from "../../../../types/campaign";
import useScreenSize from '../../../../hooks/useScreenSize';
import { formatDate } from "../../../../hooks/formatNumber";
import { Link } from "react-router-dom";

type CampaignPreviewsProps = {
    campaigns: Campaign[],
    size?: number
}

const CampaignPreviewsWidget = ({ campaigns, size = 12 }: CampaignPreviewsProps) => {
    const screenSize = useScreenSize();
    const active = useMemo(() => {
        return campaigns.filter((campaign) => campaign.adStatus === "active");
    }, [campaigns]);
    const review = useMemo(() => {
        return campaigns.filter((campaign) => campaign.adStatus === "pending approval");
    }, [campaigns]);

    const createTable = (campaigns: Campaign[], emptyMessage: string) => {
        return (
            <TableContainer sx={{ overflow: 'hidden' }}>
                <Table sx={{ minWidth: 1100 }}>
                    <TableBody>
                        {campaigns.length === 0 ? (
                            <TableRow key={0} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                    <Typography>{emptyMessage}</Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            campaigns.slice(0, 3).map((row: Campaign) =>
                                <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell>
                                        <Typography>{row.nickname}</Typography>
                                    </TableCell>
                                    <TableCell align="right">
                                        <Typography>
                                            {row.endTime * 1000 <= Date.now() ? "Ended" : "Ends"} {formatDate(row.endTime)}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )
                        )}
                        {campaigns.length > 3 &&
                            <TableRow key={0} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                    <Link to="/campaigns" style={{ textDecoration: "none" }}>
                                        <Typography>+{campaigns.length - 3} more campaigns</Typography>
                                    </Link>
                                </TableCell>
                            </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }

    return (
        <Grid size={screenSize.width < 1200 ? 12 : size}>
            <Paper elevation={5} sx={{ 
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: 2
            }}>
                <Typography variant="h6">Active Campaigns</Typography>
                {createTable(active, "No currently active campaigns")}
                <Typography variant="h6">Pending Approval</Typography>
                {createTable(review, "No campaigns awaiting approval")}
            </Paper>
        </Grid>
    )
}

export default CampaignPreviewsWidget;
